import { createApp } from "vue";
import App from "./App.vue";

const appElement = document.getElementById("app");

if (appElement) {
	createApp(App, {
		id: parseInt(appElement.dataset.id),
	}).mount(appElement);
}
